<span mat-button mat-dialog-close class="right pointer"><i id="closeOverlay" class="far fa-times-circle"></i></span>
<h1 mat-dialog-title>Assegna Valet</h1>
<div mat-dialog-content>
  <form [formGroup]="_deliveryForm" (ngSubmit)="onSubmit()" *ngIf="_deliveryForm">
    <div formGroupName="expert">
      <div class="expert__assign" *ngFor="let expert of experts; let i = index">
        <div class="input__box__label">
          <input type="radio" formControlName="id" [value]="expert.id" [id]="'expert_' + i" (change)="onExpertSelection($event, expert)"><label [for]="'expert_' + i">{{expert.user.surname}} {{expert.user.name}}</label>
        </div>
        <div *ngIf="!isTeamLeader">
          <select [ngModel]="selectedServiceId" (ngModelChange)="onServiceChange($event, expert)" [ngModelOptions]="{standalone: true}">
          <!-- <select (change)="onServiceChange($event, expert)"> -->
            <option disabled selected>Select Valet Servizio</option>
            <ng-container *ngIf="expert?.expertServices?.length">
              <option *ngFor="let service of expert.expertServices" [value]="service.id" [selected]="selectedServiceId === service?.id">{{ service?.service?.serviceName }}</option>
            </ng-container>
          </select>
        </div>
      </div>
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <div>
    <button mat-button class="btn" (click)=onSubmit() [disabled]="disableBtn">
      Salva<i class="ml-10 far fa-save"></i>
    </button>
    &nbsp;
    <a target="_blank"  mat-button class="detail-btn" [routerLink]="['/consegne', delivery?.id]" *ngIf="delivery?.id">
      DETTAGLI<i class="ml-10 far fa-eye"></i>
    </a>

  </div>
</div>